// Vendored verbatim from the Glance design system (project/components/bundle.js), plus the
// changes marked "lazarus patch". To update: copy the new bundle over this file and re-apply them.
// Plot (axes, gridlines, legend, zoom, drill-down) is ours and lives beside it in plot.js.
// Wrapped as React kit components in ../Glance.jsx; see docs/platform/glance_kit.md.
/* @ds-bundle: {"format":4,"namespace":"Glance","components":[{"name":"Card"},{"name":"SegmentGauge"},{"name":"Ring"},{"name":"ArcGauge"},{"name":"TickMeter"},{"name":"BulletBar"},{"name":"Steps"},{"name":"Waffle"},{"name":"Rings"},{"name":"TickRing"},{"name":"Sparkline"},{"name":"MiniBars"},{"name":"PosNegBars"},{"name":"CalendarHeat"},{"name":"UptimeStrip"},{"name":"Slope"},{"name":"SegmentBar"},{"name":"Donut"},{"name":"Treemap"},{"name":"RankBars"},{"name":"Funnel"},{"name":"Variance"},{"name":"RangeDots"},{"name":"Waterfall"},{"name":"DotHistogram"},{"name":"DayTimeline"},{"name":"DueDates"}]} */
/* Glance — dependency-free SVG card charts. Every chart is a pure function: options in, SVG string out.
   Colours are CSS custom properties from the system's tokens, each with a light-theme hex fallback,
   so a chart renders correctly with or without tokens.css on the page. */
(function () {
  'use strict';

  // ---------- colour ----------
  var FB = {
    'page': '#fafafa', 'card': '#ffffff', 'line': '#e8e8ea', 'grid': '#efeff1', 'track': '#ebebed',
    'ink': '#111113', 'ink-2': '#5d5d66', 'ink-3': '#6e6e77',
    'data-teal': '#0e9f86', 'data-amber': '#b98009', 'data-violet': '#6d5ce8',
    'data-rose': '#e0386a', 'data-blue': '#1f86dc', 'data-lime': '#5c9a1b',
    'teal-soft': '#bfe6dc', 'amber-soft': '#e8dfcf', 'violet-soft': '#dcd7fa',
    'rose-soft': '#f6c3cf', 'blue-soft': '#d3e6f8', 'lime-soft': '#dbeac8',
    'neutral-bar': '#7a7a84', 'now': '#f0641e', 'on-data': '#0b0b0c',
    'positive': '#0b7a5c', 'negative': '#c42651',
    'seq-1': '#6fcdb5', 'seq-2': '#2eae93', 'seq-3': '#0e8a73', 'seq-4': '#0b5f50',
    'risk-1': '#ee8fa8', 'risk-2': '#e0587f', 'risk-3': '#c2305c', 'risk-4': '#8a1d42'
  };
  var ALIAS = { teal: 'data-teal', amber: 'data-amber', violet: 'data-violet', rose: 'data-rose', blue: 'data-blue', lime: 'data-lime' };
  var SERIES = ['teal', 'amber', 'violet', 'rose', 'blue', 'lime'];

  function col(c) {
    if (!c) return 'none';
    if (c.charAt(0) === '#' || /^(rgb|rgba|hsl|hsla|oklch|var)\(/.test(c)) return c;
    var n = ALIAS[c] || c;
    return 'var(--' + n + ',' + (FB[n] || '#888888') + ')';
  }
  function soft(c) {
    if (ALIAS[c]) return c + '-soft';
    for (var k in ALIAS) if (ALIAS[k] === c) return k + '-soft';
    return 'track';
  }
  function F(c) { return ' style="fill:' + col(c) + '"'; }

  // ---------- small helpers ----------
  var MONO = 'var(--font-mono,ui-monospace,SFMono-Regular,Menlo,monospace)';
  var SANS = 'var(--font-sans,system-ui,-apple-system,Segoe UI,sans-serif)';
  var uidN = 0;
  function uid(p) { uidN += 1; return 'gl-' + (p || 'x') + '-' + uidN.toString(36); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function D(o, d) { var out = {}, k; for (k in d) out[k] = d[k]; if (o) for (k in o) if (o[k] !== undefined) out[k] = o[k]; return out; }
  function sum(a) { var s = 0; for (var i = 0; i < a.length; i++) s += +a[i] || 0; return s; }
  function tw(s, size, mono) { return String(s).length * size * (mono ? 0.6 : 0.56); }
  function fit(s, px, size, mono) {
    s = String(s); var per = size * (mono ? 0.6 : 0.56), max = Math.floor(px / per);
    if (s.length <= max) return s; if (max < 3) return ''; return s.slice(0, max - 1) + '…';
  }
  function tip(s) { return s ? ' data-tip="' + esc(s) + '"' : ''; }
  function T(x, y, s, o) {
    o = o || {};
    return '<text x="' + r2(x) + '" y="' + r2(y) + '"' + (o.anchor ? ' text-anchor="' + o.anchor + '"' : '') +
      ' style="font-family:' + (o.sans ? SANS : MONO) + ';font-size:' + (o.size || 10.5) + 'px;font-weight:' + (o.weight || 400) +
      ';fill:' + col(o.color || 'ink-3') + (o.ls ? ';letter-spacing:' + o.ls : '') + '">' + esc(s) + '</text>';
  }
  function open(w, h, label) {
    return '<svg xmlns="http://www.w3.org/2000/svg" class="gl-svg" viewBox="0 0 ' + r2(w) + ' ' + r2(h) + '" width="' + r2(w) + '" height="' + r2(h) +
      '" style="display:block;max-width:100%;height:auto;overflow:visible" role="img" aria-label="' + esc(label || 'chart') + '">';
  }
  // rect with independent corner radii (tl, tr, br, bl)
  function rr(x, y, w, h, tl, tr, br, bl) {
    if (w <= 0 || h <= 0) return '';
    var m = Math.min(w, h) / 2; tl = Math.min(tl, m); tr = Math.min(tr, m); br = Math.min(br, m); bl = Math.min(bl, m);
    return 'M' + r2(x + tl) + ',' + r2(y) + 'H' + r2(x + w - tr) + (tr ? 'A' + tr + ',' + tr + ' 0 0 1 ' + r2(x + w) + ',' + r2(y + tr) : '') +
      'V' + r2(y + h - br) + (br ? 'A' + br + ',' + br + ' 0 0 1 ' + r2(x + w - br) + ',' + r2(y + h) : '') +
      'H' + r2(x + bl) + (bl ? 'A' + bl + ',' + bl + ' 0 0 1 ' + r2(x) + ',' + r2(y + h - bl) : '') +
      'V' + r2(y + tl) + (tl ? 'A' + tl + ',' + tl + ' 0 0 1 ' + r2(x + tl) + ',' + r2(y) : '') + 'Z';
  }
  function rect(x, y, w, h, r, c, extra) {
    if (w <= 0 || h <= 0) return '';
    return '<rect x="' + r2(x) + '" y="' + r2(y) + '" width="' + r2(w) + '" height="' + r2(h) + '" rx="' + r2(Math.min(r, w / 2, h / 2)) + '"' + F(c) + (extra || '') + '/>';
  }
  // angle 0 = 12 o'clock, clockwise, degrees
  function pol(cx, cy, r, a) { var t = a * Math.PI / 180; return [cx + r * Math.sin(t), cy - r * Math.cos(t)]; }
  function arc(cx, cy, r, a0, a1) {
    var p0 = pol(cx, cy, r, a0), p1 = pol(cx, cy, r, a1);
    return 'M' + r2(p0[0]) + ',' + r2(p0[1]) + 'A' + r2(r) + ',' + r2(r) + ' 0 ' + (a1 - a0 > 180 ? 1 : 0) + ' 1 ' + r2(p1[0]) + ',' + r2(p1[1]);
  }
  function sector(cx, cy, R, r, a0, a1) {
    var o0 = pol(cx, cy, R, a0), o1 = pol(cx, cy, R, a1), i1 = pol(cx, cy, r, a1), i0 = pol(cx, cy, r, a0), L = a1 - a0 > 180 ? 1 : 0;
    return 'M' + r2(o0[0]) + ',' + r2(o0[1]) + 'A' + r2(R) + ',' + r2(R) + ' 0 ' + L + ' 1 ' + r2(o1[0]) + ',' + r2(o1[1]) +
      'L' + r2(i1[0]) + ',' + r2(i1[1]) + 'A' + r2(r) + ',' + r2(r) + ' 0 ' + L + ' 0 ' + r2(i0[0]) + ',' + r2(i0[1]) + 'Z';
  }
  function stroke(c, w, extra) { return ' style="fill:none;stroke:' + col(c) + ';stroke-width:' + w + ';stroke-linecap:round;stroke-linejoin:round' + (extra || '') + '"'; }
  function items(a) { return (a || []).map(function (d, i) { return typeof d === 'number' ? { label: String(i + 1), value: d } : d; }); }

  // ---------- number formats (Indian grouping) ----------
  function trim(x, d) { return String(+(+x).toFixed(d)); }
  var fmt = {
    num: function (v, d) { return Number(v).toLocaleString('en-IN', { maximumFractionDigits: d == null ? 0 : d }); },
    compact: function (v, d) {
      var a = Math.abs(v), s = v < 0 ? '−' : '';
      if (a >= 1e7) return s + trim(a / 1e7, d == null ? 2 : d) + ' Cr';
      if (a >= 1e5) return s + trim(a / 1e5, d == null ? 1 : d) + ' L';
      if (a >= 1e3) return s + trim(a / 1e3, d == null ? 1 : d) + 'K';
      return s + trim(a, d == null ? 0 : d);
    },
    inr: function (v, d) { var c = fmt.compact(v, d); return c.charAt(0) === '−' ? '−₹' + c.slice(1) : '₹' + c; },
    inrFull: function (v) { return (v < 0 ? '−' : '') + '₹' + fmt.num(Math.abs(v)); },
    pct: function (v, d) { return trim(v * 100, d == null ? 0 : d) + '%'; },
    dur: function (h) { var m = Math.round(h * 60), H = Math.floor(m / 60), M = m % 60; return H && M ? H + 'h ' + M + 'm' : H ? H + 'h' : M + 'm'; },
    days: function (v) { return trim(v, 0) + 'd'; },
    x: function (v) { return (+v).toFixed(1) + '×'; },
    signed: function (v, unit) { return (v > 0 ? '+' : v < 0 ? '−' : '') + trim(Math.abs(v), 1) + (unit || ''); }
  };
  var PRESET = {
    inr: function (v) { return fmt.inr(v); }, 'inr-full': fmt.inrFull, num: function (v) { return fmt.num(v); },
    compact: function (v) { return fmt.compact(v); }, pct: function (v) { return fmt.pct(v); },
    pct100: function (v) { return trim(v, 1) + '%'; }, dur: fmt.dur, days: fmt.days, x: fmt.x,
    'signed-pct': function (v) { return fmt.signed(v, '%'); },
    'signed-inr': function (v) { return (v > 0 ? '+' : v < 0 ? '−' : '') + fmt.inr(Math.abs(v)); }
  };
  function FMT(f, dflt) { if (typeof f === 'function') return f; if (f && PRESET[f]) return PRESET[f]; return dflt || function (v) { return fmt.num(v, 1); }; }

  // =====================================================================
  // Card — the metric card shell (HTML string)
  // =====================================================================
  function Card(o) {
    o = o || {};
    var head = '<div class="gl-card-head"><span class="gl-label">' + esc(o.label || '') + '</span>' + (o.meta ? '<span class="gl-meta">' + esc(o.meta) + '</span>' : '') + '</div>';
    var val = '';
    if (o.value != null) {
      val = '<div class="gl-card-value">' + (o.prefix ? '<span class="gl-unit gl-pre">' + esc(o.prefix) + '</span>' : '') +
        '<span class="gl-value">' + esc(o.value) + '</span>' + (o.unit ? '<span class="gl-unit">' + esc(o.unit) + '</span>' : '') +
        (o.aside ? '<span class="gl-aside">' + esc(o.aside) + '</span>' : '') + '</div>';
    }
    var delta = '';
    if (o.delta) {
      var d = typeof o.delta === 'string' ? { text: o.delta } : o.delta;
      var ar = d.dir === 'up' ? '↗ ' : d.dir === 'down' ? '↘ ' : '';
      delta = '<div class="gl-delta gl-delta-' + (d.tone || 'neutral') + '">' + ar + esc(d.text) + '</div>';
    }
    var sub = o.sub ? '<div class="gl-sub">' + esc(o.sub) + '</div>' : '';
    var body = o.lead ? '<div class="gl-card-lead">' + o.lead + '<div class="gl-card-lead-text">' + val + delta + sub + '</div></div>' : val + delta + sub;
    var chart = '';
    if (o.chart) {
      chart = typeof o.chart === 'string' ? '<div class="gl-card-chart">' + o.chart + '</div>'
        : '<div class="gl-card-chart" data-gl="' + esc(JSON.stringify(o.chart)) + '"></div>';
    }
    var foot = o.foot ? '<div class="gl-foot">' + esc(o.foot) + '</div>' : '';
    return '<div class="gl-card' + (o.className ? ' ' + esc(o.className) : '') + '">' + head + body + chart + foot + '</div>';
  }

  // =====================================================================
  // METERS
  // =====================================================================
  function SegmentGauge(o) {
    o = D(o, { value: 0, max: 1, target: null, segments: 22, sweep: 230, color: 'teal', width: 200, tick: 12, display: null, format: null, label: null });
    var W = o.width, t = o.tick, r = Math.min(W / 2 - t / 2 - 10, 66), cx = W / 2, cy = r + t / 2 + 10, half = o.sweep / 2, n = o.segments;
    var low = cy - r * Math.cos(half * Math.PI / 180), H = Math.ceil(low + t / 2 + 6);
    var f = FMT(o.format, fmt.x), frac = clamp(o.value / o.max, 0, 1), on = Math.round(frac * n);
    var arcLen = r * o.sweep * Math.PI / 180, tW = Math.min(7.5, arcLen / n * 0.62);
    var label = o.label || (f(o.value) + (o.target != null ? ', target ' + f(o.target) : '') + ', scale to ' + f(o.max));
    var s = open(W, H, label) + '<g' + tip(label) + '>';
    for (var i = 0; i < n; i++) {
      var a = -half + (i + 0.5) * o.sweep / n;
      s += '<rect x="' + r2(cx - tW / 2) + '" y="' + r2(cy - r - t / 2) + '" width="' + r2(tW) + '" height="' + t + '" rx="2" transform="rotate(' + r2(a) + ' ' + r2(cx) + ' ' + r2(cy) + ')"' + F(i < on ? o.color : 'track') + '/>';
    }
    if (o.target != null) {
      var ta = -half + clamp(o.target / o.max, 0, 1) * o.sweep, p1 = pol(cx, cy, r + t / 2 + 1, ta), p2 = pol(cx, cy, r + t / 2 + 8, ta);
      s += '<path d="M' + r2(p1[0]) + ',' + r2(p1[1]) + 'L' + r2(p2[0]) + ',' + r2(p2[1]) + '"' + stroke('ink', 2.5) + '/>';
    }
    s += '</g>';
    var disp = o.display != null ? o.display : f(o.value);
    if (disp !== '') s += T(cx, cy + 12, disp, { sans: 1, size: Math.round(Math.min(30, r * 0.46, 1.4 * r / (String(disp).length * 0.56))), weight: 500, color: 'ink', anchor: 'middle' });
    return s + '</svg>';
  }

  function Ring(o) {
    o = D(o, { value: 0, max: 1, size: 72, thickness: 8, color: 'blue', display: null, sub: null, label: null });
    var S = o.size, t = o.thickness, r = (S - t) / 2 - 1, c = S / 2, f = clamp(o.value / o.max, 0, 1);
    var label = o.label || (Math.round(f * 100) + '% of ' + fmt.num(o.max));
    var s = open(S, S, label) + '<g' + tip(label) + '>';
    s += '<circle cx="' + c + '" cy="' + c + '" r="' + r2(r) + '"' + stroke('track', t) + '/>';
    if (f >= 0.999) s += '<circle cx="' + c + '" cy="' + c + '" r="' + r2(r) + '"' + stroke(o.color, t) + '/>';
    else if (f > 0) s += '<path d="' + arc(c, c, r, 0, f * 360) + '"' + stroke(o.color, t) + '/>';
    s += '</g>';
    if (o.display) s += T(c, c + (o.sub ? 2 : S * 0.085), o.display, { sans: 1, size: Math.round(S * 0.24), weight: 500, color: 'ink', anchor: 'middle' });
    if (o.sub) s += T(c, c + S * 0.2, o.sub, { size: Math.max(9, Math.round(S * 0.11)), anchor: 'middle' });
    return s + '</svg>';
  }

  function ArcGauge(o) {
    o = D(o, { value: 0, max: 1, min: 0, width: 200, thickness: 12, bands: null, color: null, display: null, sub: null, format: null, minLabel: null, maxLabel: null, label: null });
    var W = o.width, t = o.thickness, cx = W / 2, r = W / 2 - t / 2 - 12, cy = r + t / 2 + 12, f = FMT(o.format, fmt.pct);
    var bands = o.bands || [{ to: o.max * 0.75, color: 'teal' }, { to: o.max * 0.9, color: 'amber' }, { to: o.max, color: 'rose' }];
    var span = o.max - o.min, frac = clamp((o.value - o.min) / span, 0, 1), ang = function (v) { return -90 + clamp((v - o.min) / span, 0, 1) * 180; };
    var vc = o.color; if (!vc) { vc = bands[bands.length - 1].color; for (var b = 0; b < bands.length; b++) if (o.value <= bands[b].to) { vc = bands[b].color; break; } }
    var label = o.label || (f(o.value) + ' of ' + f(o.max));
    var H = cy + 24, s = open(W, H, label);
    var from = o.min;
    for (var i = 0; i < bands.length; i++) {
      var a0 = ang(from) + (i ? 1.2 : 0), a1 = ang(bands[i].to) - (i < bands.length - 1 ? 1.2 : 0);
      if (a1 > a0) s += '<path d="' + arc(cx, cy, r + t / 2 + 6, a0, a1) + '" style="fill:none;stroke:' + col(bands[i].color) + ';stroke-width:3"' + tip('Zone to ' + f(bands[i].to)) + '/>';
      from = bands[i].to;
    }
    s += '<path d="' + arc(cx, cy, r, -90, 90) + '"' + stroke('track', t) + '/>';
    if (frac > 0) s += '<path d="' + arc(cx, cy, r, -90, -90 + frac * 180) + '"' + stroke(vc, t) + tip(label) + '/>';
    var disp = o.display != null ? o.display : f(o.value);
    s += T(cx, cy - 6, disp, { sans: 1, size: Math.round(r * 0.42), weight: 500, color: 'ink', anchor: 'middle' });
    if (o.sub) s += T(cx, cy + 12, o.sub, { anchor: 'middle' });
    s += T(cx - r, cy + 20, o.minLabel != null ? o.minLabel : f(o.min), { anchor: 'middle' });
    s += T(cx + r, cy + 20, o.maxLabel != null ? o.maxLabel : f(o.max), { anchor: 'middle' });
    return s + '</svg>';
  }

  function TickMeter(o) {
    o = D(o, { value: 0, max: 6, step: 0.25, width: 240, height: 30, zones: null, labels: null, format: null, label: null });
    var W = o.width, h = o.height, n = Math.max(1, Math.round(o.max / o.step)), slot = W / n, gap = Math.max(2, slot * 0.4), bw = slot - gap + gap / n;
    var zones = o.zones || [{ to: o.max, color: 'teal' }], f = FMT(o.format, fmt.dur), on = Math.round(o.value / o.step);
    var label = o.label || (f(o.value) + ' on a 0 to ' + f(o.max) + ' scale');
    var H = h + (o.labels ? 20 : 2), s = open(W, H, label);
    for (var i = 0; i < n; i++) {
      var v0 = i * o.step, z = zones[zones.length - 1];
      for (var k = 0; k < zones.length; k++) if (v0 < zones[k].to - 1e-9) { z = zones[k]; break; }
      var filled = i < on, c = filled ? z.color : (z.soft || soft(z.color));
      s += rect(i * slot, 0, bw, h, Math.min(bw / 2, 3.5), c, tip(f(v0) + '–' + f(v0 + o.step) + (z.label ? ' · ' + z.label : '')));
    }
    if (o.labels) o.labels.forEach(function (L) {
      var x = L.at / o.max * W, anc = L.at <= 0 ? 'start' : L.at >= o.max ? 'end' : 'middle';
      s += T(x, h + 16, L.text != null ? L.text : f(L.at), { anchor: anc, size: 11 });
    });
    return s + '</svg>';
  }

  function BulletBar(o) {
    o = D(o, { value: 0, projected: null, target: null, max: 1, width: 280, height: 14, color: 'teal', startLabel: null, targetLabel: null, format: null, label: null });
    var W = o.width, h = o.height, y0 = 5, f = FMT(o.format, fmt.inr), sx = function (v) { return clamp(v / o.max, 0, 1) * W; };
    var hasLab = o.startLabel !== false || o.targetLabel, H = y0 + h + 5 + (hasLab ? 16 : 0), pid = uid('hatch');
    var label = o.label || (f(o.value) + ' actual' + (o.projected != null ? ', ' + f(o.projected) + ' projected' : '') + (o.target != null ? ', target ' + f(o.target) : ''));
    var s = open(W, H, label);
    s += '<defs><pattern id="' + pid + '" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="6" height="6"' + F(soft(o.color)) +
      '/><rect width="2.6" height="6"' + F(o.color) + ' opacity=".55"/></pattern></defs>';
    s += rect(0, y0, W, h, h / 2, 'track');
    var xa = sx(o.value);
    if (o.projected != null && o.projected > o.value) {
      var xp = sx(o.projected);
      s += '<rect x="' + r2(xa + 3) + '" y="' + y0 + '" width="' + r2(Math.max(0, xp - xa - 3)) + '" height="' + h + '" rx="3" style="fill:url(#' + pid + ')"' + tip(f(o.projected) + ' projected (' + f(o.projected - o.value) + ' in pipeline)') + '/>';
    }
    s += rect(0, y0, xa, h, Math.min(h / 2, 5), o.color, tip(f(o.value) + ' actual'));
    if (o.target != null) {
      var xt = sx(o.target);
      s += rect(xt - 3.5, y0, 7, h, 0, 'card');
      s += '<path d="M' + r2(xt) + ',' + (y0 - 4) + 'V' + (y0 + h + 4) + '"' + stroke('ink', 2.5) + tip('Target ' + f(o.target)) + '/>';
    }
    if (hasLab) {
      if (o.startLabel !== false) s += T(0, H - 1, o.startLabel != null ? o.startLabel : f(0), { size: 11 });
      if (o.target != null) {
        var tl = o.targetLabel != null ? o.targetLabel : f(o.target) + ' target', w = tw(tl, 11, 1);
        s += T(clamp(sx(o.target), w / 2, W - w / 2), H - 1, tl, { anchor: 'middle', size: 11 });
      }
    }
    return s + '</svg>';
  }

  function Steps(o) {
    o = D(o, { steps: [], width: 280, color: 'teal', label: null });
    var st = o.steps, n = st.length, W = o.width, pad = 8, y = 10, H = 40;
    var x = function (i) { return n < 2 ? W / 2 : pad + i * (W - 2 * pad) / (n - 1); };
    var done = st.filter(function (d) { return d.state === 'done'; }).length;
    var s = open(W, H, o.label || (done + ' of ' + n + ' steps done'));
    for (var i = 0; i < n - 1; i++) {
      var ok = st[i].state === 'done' && st[i + 1].state !== 'todo';
      s += '<path d="M' + r2(x(i) + 9) + ',' + y + 'H' + r2(x(i + 1) - 9) + '"' + stroke(ok ? o.color : 'track', 2) + '/>';
    }
    st.forEach(function (d, i) {
      var cx = x(i), t = tip(d.label + ' · ' + (d.state === 'done' ? 'done' : d.state === 'active' ? 'in progress' : 'to do'));
      s += '<g' + t + '>';
      if (d.state === 'done') {
        s += '<circle cx="' + r2(cx) + '" cy="' + y + '" r="7"' + F(o.color) + '/>';
        s += '<path d="M' + r2(cx - 3.2) + ',' + (y + 0.2) + 'l2.2,2.2l4.2,-4.4"' + stroke('card', 1.8) + '/>';
      } else if (d.state === 'active') {
        s += '<circle cx="' + r2(cx) + '" cy="' + y + '" r="6.5" style="fill:' + col('card') + ';stroke:' + col(o.color) + ';stroke-width:2"/>';
        s += '<circle cx="' + r2(cx) + '" cy="' + y + '" r="3"' + F(o.color) + '/>';
      } else {
        s += '<circle cx="' + r2(cx) + '" cy="' + y + '" r="6" style="fill:' + col('card') + ';stroke:' + col('track') + ';stroke-width:2"/>';
      }
      s += '</g>';
      var anc = n > 1 && i === 0 ? 'start' : n > 1 && i === n - 1 ? 'end' : 'middle', lx = anc === 'start' ? cx - 7 : anc === 'end' ? cx + 7 : cx;
      s += T(lx, 36, fit(d.label, (W / n) * (anc === 'middle' ? 1 : 1.2), 10, 1), { anchor: anc, size: 10, color: d.state === 'todo' ? 'ink-3' : 'ink-2' });
    });
    return s + '</svg>';
  }

  function Waffle(o) {
    o = D(o, { value: 0, total: 100, cols: 10, rows: 10, cell: 11, gap: 3, color: 'teal', shape: 'square', label: null });
    var N = o.cols * o.rows, on = Math.round(clamp(o.value / o.total, 0, 1) * N), p = o.cell + o.gap;
    var W = o.cols * p - o.gap, H = o.rows * p - o.gap, label = o.label || (fmt.num(o.value) + ' of ' + fmt.num(o.total));
    var s = open(W, H, label) + '<g' + tip(label) + '>';
    for (var i = 0; i < N; i++) {
      var cx = (i % o.cols) * p, cy = Math.floor(i / o.cols) * p, c = i < on ? o.color : 'track';
      s += o.shape === 'dot' ? '<circle cx="' + r2(cx + o.cell / 2) + '" cy="' + r2(cy + o.cell / 2) + '" r="' + r2(o.cell / 2) + '"' + F(c) + '/>' : rect(cx, cy, o.cell, o.cell, 2.5, c);
    }
    return s + '</g></svg>';
  }

  function Rings(o) {
    o = D(o, { rings: [], size: 104, thickness: 9, gap: 3, legend: true, format: null, label: null });
    var S = o.size, t = o.thickness, c = S / 2, f = FMT(o.format, fmt.pct), lw = o.legend ? 150 : 0, W = S + (lw ? 16 + lw : 0);
    var H = Math.max(S, o.rings.length * 24), cy = H / 2;
    var s = open(W, H, o.label || o.rings.map(function (d) { return d.label + ' ' + f(d.value / (d.max || 1)); }).join(', '));
    o.rings.forEach(function (d, k) {
      var r = S / 2 - t / 2 - 1 - k * (t + o.gap), fr = clamp(d.value / (d.max || 1), 0, 1), cc = d.color || SERIES[k];
      if (r <= t / 2) return;
      s += '<g' + tip(d.label + ' · ' + f(d.value / (d.max || 1))) + '>';
      s += '<circle cx="' + c + '" cy="' + r2(cy) + '" r="' + r2(r) + '"' + stroke(soft(cc), t) + '/>';
      if (fr >= 0.999) s += '<circle cx="' + c + '" cy="' + r2(cy) + '" r="' + r2(r) + '"' + stroke(cc, t) + '/>';
      else if (fr > 0) s += '<path d="' + arc(c, cy, r, 0, fr * 360) + '"' + stroke(cc, t) + '/>';
      s += '</g>';
      if (lw) {
        var ly = cy - (o.rings.length - 1) * 12 + k * 24;
        s += '<circle cx="' + (S + 20) + '" cy="' + r2(ly - 4) + '" r="4"' + F(cc) + '/>';
        s += T(S + 30, ly, fit(d.label, lw - 60, 12), { sans: 1, size: 12, color: 'ink-2' });
        s += T(W, ly, f(d.value / (d.max || 1)), { anchor: 'end', size: 11.5, color: 'ink' });
      }
    });
    return s + '</svg>';
  }

  function TickRing(o) {
    o = D(o, { value: 0, total: 30, size: 104, tick: 10, tickW: 3, color: 'teal', display: null, sub: null, label: null });
    var S = o.size, c = S / 2, r = S / 2 - o.tick / 2 - 1, n = Math.max(1, Math.round(o.total)), used = n - Math.round(clamp(o.value, 0, n));
    var label = o.label || (o.value + ' of ' + o.total + ' left'), s = open(S, S, label) + '<g' + tip(label) + '>';
    for (var i = 0; i < n; i++) {
      var a = (i + 0.5) * 360 / n;
      s += '<rect x="' + r2(c - o.tickW / 2) + '" y="' + r2(c - r - o.tick / 2) + '" width="' + o.tickW + '" height="' + o.tick + '" rx="' + r2(o.tickW / 2) + '" transform="rotate(' + r2(a) + ' ' + c + ' ' + c + ')"' + F(i < used ? 'track' : o.color) + '/>';
    }
    s += '</g>';
    s += T(c, c + (o.sub ? 3 : S * 0.1), o.display != null ? o.display : String(o.value), { sans: 1, size: Math.round(S * 0.28), weight: 500, color: 'ink', anchor: 'middle' });
    if (o.sub) s += T(c, c + S * 0.2, o.sub, { anchor: 'middle', size: 10 });
    return s + '</svg>';
  }

  // =====================================================================
  // TRENDS
  // =====================================================================
  function Sparkline(o) {
    o = D(o, { data: [], compare: null, keys: null, width: 220, height: 48, color: 'blue', area: true, dot: true, min: null, max: null, labels: null, format: null, label: null });
    var d = o.data.map(Number), n = d.length, W = o.width, H = o.height, f = FMT(o.format);
    if (n < 2) return open(W, H, 'no data') + '</svg>';
    var all = d.concat(o.compare || []), lo = o.min != null ? o.min : Math.min.apply(null, all), hi = o.max != null ? o.max : Math.max.apply(null, all);
    if (hi === lo) { hi += 1; lo -= 1; }
    var top = 6, xr = W - 6, x = function (i) { return i / (n - 1) * xr; }, y = function (v) { return top + (1 - (v - lo) / (hi - lo)) * (H - top - 3); };
    var line = function (arr) { return arr.map(function (v, i) { return (i ? 'L' : 'M') + r2(x(i)) + ',' + r2(y(v)); }).join(''); };
    var TH = H + (o.labels || o.keys ? 16 : 0);
    var s = open(W, TH, o.label || ('Trend from ' + f(d[0]) + ' to ' + f(d[n - 1])));
    if (o.compare && o.compare.length > 1) s += '<path d="' + line(o.compare.slice(0, n)) + '"' + stroke('ink-3', 1.5, ';stroke-opacity:.45') + '/>';
    if (o.area) s += '<path d="' + line(d) + 'L' + r2(x(n - 1)) + ',' + H + 'L0,' + H + 'Z" style="fill:' + col(o.color) + ';fill-opacity:.1"/>';
    s += '<path d="' + line(d) + '"' + stroke(o.color, 2) + '/>';
    if (o.dot) s += '<circle cx="' + r2(x(n - 1)) + '" cy="' + r2(y(d[n - 1])) + '" r="4" style="fill:' + col(o.color) + ';stroke:' + col('card') + ';stroke-width:2"/>';
    var lab = o.labels || [];
    for (var i = 0; i < n; i++) {
      var w = xr / (n - 1);
      s += '<rect x="' + r2(x(i) - w / 2) + '" y="0" width="' + r2(w) + '" height="' + H + '" fill="transparent"' + tip((lab.length === n ? lab[i] + ' · ' : '') + f(d[i]) + (o.compare && o.compare[i] != null ? ' (prev ' + f(o.compare[i]) + ')' : '')) + '/>';
    }
    if (o.labels) {
      var first = lab.length === n ? lab[0] : lab[0], last = lab.length === n ? lab[n - 1] : lab[lab.length - 1];
      s += T(0, TH - 1, first, { size: 10.5 }) + T(W, TH - 1, last, { size: 10.5, anchor: 'end' });
    }
    if (o.keys) {
      var k1 = o.keys[0], k2 = o.keys[1] || '', kw = 12 + tw(k1, 10.5, 1) + (k2 ? 16 + 12 + tw(k2, 10.5, 1) : 0), kx = W / 2 - kw / 2;
      s += '<path d="M' + r2(kx) + ',' + (TH - 4.5) + 'h8"' + stroke(o.color, 2) + '/>' + T(kx + 12, TH - 1, k1, { size: 10.5, color: 'ink-2' });
      if (k2) { var kx2 = kx + 12 + tw(k1, 10.5, 1) + 16; s += '<path d="M' + r2(kx2) + ',' + (TH - 4.5) + 'h8"' + stroke('ink-3', 1.5, ';stroke-opacity:.6') + '/>' + T(kx2 + 12, TH - 1, k2, { size: 10.5, color: 'ink-2' }); }
    }
    return s + '</svg>';
  }

  function MiniBars(o) {
    o = D(o, { data: [], width: 220, height: 56, color: 'teal', highlight: 'last', max: null, labels: null, format: null, label: null });
    var d = items(o.data), n = d.length, W = o.width, H = o.height, f = FMT(o.format);
    var mx = o.max || Math.max.apply(null, d.map(function (e) { return e.value; }).concat([1e-9]));
    var slot = W / n, bw = Math.min(24, slot * 0.72), hi = o.highlight === 'last' ? n - 1 : o.highlight === 'max' ? d.reduce(function (b, e, i) { return e.value > d[b].value ? i : b; }, 0) : o.highlight;
    var TH = H + 1 + (o.labels ? 16 : 0), s = open(W, TH, o.label || (n + ' bars, latest ' + f(d[n - 1].value)));
    d.forEach(function (e, i) {
      var h = Math.max(2, e.value / mx * (H - 2)), x = i * slot + (slot - bw) / 2, c = hi == null || hi === i ? o.color : soft(o.color);
      s += '<path d="' + rr(x, H - h, bw, h, 3, 3, 0, 0) + '"' + F(c) + tip(e.label + ' · ' + f(e.value)) + '/>';
    });
    s += '<path d="M0,' + (H + 0.5) + 'H' + W + '"' + stroke('line', 1, ';stroke-linecap:butt') + '/>';
    if (o.labels) {
      var lb = o.labels, L = lb.length === n ? [lb[0], lb[n - 1]] : [lb[0], lb[lb.length - 1]];
      s += T(slot / 2 - bw / 2, TH - 1, L[0], { size: 10.5 }) + T(W - slot / 2 + bw / 2, TH - 1, L[1], { size: 10.5, anchor: 'end' });
    }
    return s + '</svg>';
  }

  function PosNegBars(o) {
    o = D(o, { data: [], width: 220, height: 64, pos: 'teal', neg: 'rose', labels: null, format: null, label: null });
    var d = items(o.data), n = d.length, W = o.width, H = o.height, f = FMT(o.format, fmt.inr);
    var vals = d.map(function (e) { return e.value; }), mx = Math.max.apply(null, vals.concat([0])), mn = Math.min.apply(null, vals.concat([0]));
    var span = (mx - mn) || 1, y0 = 1 + mx / span * (H - 2), slot = W / n, bw = Math.min(24, slot * 0.66);
    var TH = H + (o.labels ? 16 : 0), s = open(W, TH, o.label || (vals.filter(function (v) { return v >= 0; }).length + ' up, ' + vals.filter(function (v) { return v < 0; }).length + ' down'));
    d.forEach(function (e, i) {
      var h = Math.max(1.5, Math.abs(e.value) / span * (H - 2)), x = i * slot + (slot - bw) / 2;
      s += e.value >= 0 ? '<path d="' + rr(x, y0 - h - 1, bw, h, 2.5, 2.5, 0, 0) + '"' + F(o.pos) + tip(e.label + ' · ' + f(e.value)) + '/>'
        : '<path d="' + rr(x, y0 + 1, bw, h, 0, 0, 2.5, 2.5) + '"' + F(o.neg) + tip(e.label + ' · ' + f(e.value)) + '/>';
    });
    s += '<path d="M0,' + r2(y0) + 'H' + W + '"' + stroke('ink-3', 1, ';stroke-linecap:butt;stroke-opacity:.5') + '/>';
    if (o.labels) s += T(0, TH - 1, o.labels[0], { size: 10.5 }) + T(W, TH - 1, o.labels[o.labels.length - 1], { size: 10.5, anchor: 'end' });
    return s + '</svg>';
  }

  function CalendarHeat(o) {
    o = D(o, { data: [], cell: 12, gap: 3, steps: 4, rowLabels: ['M', '', 'W', '', 'F', '', ''], legend: true, dates: null, format: null, label: null });
    var d = o.data, p = o.cell + o.gap, weeks = Math.ceil(d.length / 7), lx = o.rowLabels ? 14 : 0, f = FMT(o.format);
    var mx = Math.max.apply(null, d.concat([1e-9])), W = lx + weeks * p - o.gap, gridH = 7 * p - o.gap, H = gridH + (o.legend ? 22 : 0);
    W = Math.max(W, o.legend ? 150 : 0);
    var s = open(W, H, o.label || (weeks + ' weeks of daily activity, peak ' + f(mx)));
    if (o.rowLabels) o.rowLabels.forEach(function (L, r) { if (L) s += T(0, r * p + o.cell - 2, L, { size: 9.5 }); });
    d.forEach(function (v, i) {
      var w = Math.floor(i / 7), r = i % 7, k = v > 0 ? Math.max(1, Math.ceil(v / mx * o.steps)) : 0;
      s += rect(lx + w * p, r * p, o.cell, o.cell, 2.5, k ? 'seq-' + k : 'track', tip((o.dates ? o.dates[i] + ' · ' : '') + f(v)));
    });
    if (o.legend) {
      var ly = gridH + 10, xe = W - 26, sz = 9;
      s += T(xe - (o.steps + 1) * (sz + 3) - 4, ly + 9, 'Less', { size: 9.5, anchor: 'end' });
      for (var k = 0; k <= o.steps; k++) s += rect(xe - (o.steps + 1 - k) * (sz + 3), ly + 1, sz, sz, 2, k ? 'seq-' + k : 'track');
      s += T(W, ly + 9, 'More', { size: 9.5, anchor: 'end' });
    }
    return s + '</svg>';
  }

  function UptimeStrip(o) {
    o = D(o, { data: [], width: 240, height: 26, colors: null, labels: null, dates: null, label: null });
    var C = o.colors || { ok: 'teal', warn: 'amber', fail: 'rose', none: 'track' }, NAME = { ok: 'Healthy', warn: 'Degraded', fail: 'Failed', none: 'No data' };
    var n = o.data.length, W = o.width, h = o.height, slot = W / n, bw = slot * 0.64 + (slot * 0.36) / n;
    var bad = o.data.filter(function (x) { return x === 'fail'; }).length, TH = h + (o.labels ? 18 : 0);
    var s = open(W, TH, o.label || (n + ' days, ' + bad + ' failed'));
    o.data.forEach(function (st, i) { s += rect(i * slot, 0, bw, h, Math.min(bw / 2, 2.5), C[st] || 'track', tip((o.dates ? o.dates[i] : (n - i - 1) + 'd ago') + ' · ' + (NAME[st] || st))); });
    if (o.labels) s += T(0, TH - 1, o.labels[0], { size: 10.5 }) + T(W, TH - 1, o.labels[1], { size: 10.5, anchor: 'end' });
    return s + '</svg>';
  }

  function Slope(o) {
    o = D(o, { series: [], from: '', to: '', width: 260, height: 130, format: null, highlight: null, label: null });
    var W = o.width, H = o.height, f = FMT(o.format), x1 = 46, x2 = W - 104, top = 26, bot = H - 8;
    var all = []; o.series.forEach(function (d) { all.push(d.a, d.b); });
    var lo = Math.min.apply(null, all), hi = Math.max.apply(null, all); if (hi === lo) { hi += 1; lo -= 1; }
    var y = function (v) { return top + (1 - (v - lo) / (hi - lo)) * (bot - top); };
    var s = open(W, H, o.label || o.series.map(function (d) { return d.label + ' ' + f(d.a) + ' to ' + f(d.b); }).join(', '));
    s += T(x1, 11, o.from, { anchor: 'middle', size: 10.5 }) + T(x2, 11, o.to, { anchor: 'middle', size: 10.5 });
    s += '<path d="M' + x1 + ',' + (top - 6) + 'V' + (bot + 4) + 'M' + x2 + ',' + (top - 6) + 'V' + (bot + 4) + '"' + stroke('grid', 1, ';stroke-linecap:butt') + '/>';
    function spread(arr) { arr.sort(function (a, b) { return a.y - b.y; }); for (var i = 1; i < arr.length; i++) if (arr[i].y - arr[i - 1].y < 14) arr[i].y = arr[i - 1].y + 14; return arr; }
    var R = [], Lft = [];
    o.series.forEach(function (d, i) {
      var c = o.highlight == null ? (d.color || SERIES[i]) : (o.highlight === i || o.highlight === d.label ? (d.color || SERIES[0]) : 'neutral-bar');
      var ya = y(d.a), yb = y(d.b), t = tip(d.label + ': ' + f(d.a) + ' → ' + f(d.b));
      s += '<g' + t + '><path d="M' + x1 + ',' + r2(ya) + 'L' + x2 + ',' + r2(yb) + '"' + stroke(c, 2) + '/>';
      s += '<circle cx="' + x1 + '" cy="' + r2(ya) + '" r="4" style="fill:' + col(c) + ';stroke:' + col('card') + ';stroke-width:2"/>';
      s += '<circle cx="' + x2 + '" cy="' + r2(yb) + '" r="4" style="fill:' + col(c) + ';stroke:' + col('card') + ';stroke-width:2"/></g>';
      R.push({ y: yb, y0: yb, d: d }); Lft.push({ y: ya, y0: ya, d: d });
    });
    spread(R).forEach(function (e) {
      if (Math.abs(e.y - e.y0) > 1) s += '<path d="M' + (x2 + 6) + ',' + r2(e.y0) + 'L' + (x2 + 12) + ',' + r2(e.y - 3.5) + '"' + stroke('ink-3', 1) + '/>';
      s += T(x2 + 14, e.y + 3.5, f(e.d.b), { size: 11, color: 'ink' }) + T(x2 + 18 + tw(f(e.d.b), 11, 1), e.y + 3.5, fit(e.d.label, W - x2 - 22 - tw(f(e.d.b), 11, 1), 11.5), { sans: 1, size: 11.5, color: 'ink-2' });
    });
    spread(Lft).forEach(function (e) {
      if (Math.abs(e.y - e.y0) > 1) s += '<path d="M' + (x1 - 6) + ',' + r2(e.y0) + 'L' + (x1 - 12) + ',' + r2(e.y - 3.5) + '"' + stroke('ink-3', 1) + '/>';
      s += T(x1 - 14, e.y + 3.5, f(e.d.a), { size: 11, color: 'ink-2', anchor: 'end' });
    });
    return s + '</svg>';
  }

  // =====================================================================
  // PARTS OF A WHOLE
  // =====================================================================
  function SegmentBar(o) {
    o = D(o, { segments: [], max: null, width: 280, height: 14, gap: 3, radius: 3.5, legend: false, format: null, label: null });
    var seg = o.segments.filter(function (e) { return e.value > 0; }), tot = sum(seg.map(function (e) { return e.value; }));
    var total = o.max || tot || 1, W = o.width, h = o.height, f = FMT(o.format), sc = W / total, x = 0, rest = o.max && tot < o.max;
    var legendRows = [];
    if (o.legend) {
      var lx = 0, row = 0;
      seg.forEach(function (e, i) {
        var t1 = e.label, t2 = o.legend === 'pct' ? fmt.pct(e.value / tot) : f(e.value), w = 14 + tw(t1, 11.5) * 1.08 + 7 + tw(t2, 11, 1) + 18;
        if (lx + w > W && lx > 0) { lx = 0; row++; }
        legendRows.push({ x: lx, row: row, e: e, i: i, t1: t1, t2: t2 }); lx += w;
      });
    }
    var nrows = legendRows.length ? legendRows[legendRows.length - 1].row + 1 : 0, H = h + (nrows ? 10 + nrows * 20 : 0);
    var s = open(W, H, o.label || seg.map(function (e) { return e.label + ' ' + f(e.value); }).join(', ') + (rest ? ', ' + f(o.max - tot) + ' remaining' : ''));
    seg.forEach(function (e, i) {
      var w = e.value * sc, last = i === seg.length - 1 && !rest;
      s += rect(x, 0, w - (last ? 0 : o.gap), h, o.radius, e.color || SERIES[i % SERIES.length], tip(e.label + ' · ' + f(e.value) + ' (' + fmt.pct(e.value / total) + ')'));
      x += w;
    });
    if (rest) s += rect(x, 0, W - x, h, o.radius, 'track', tip(f(o.max - tot) + ' remaining'));
    legendRows.forEach(function (L) {
      var y = h + 10 + L.row * 20 + 11;
      s += '<circle cx="' + r2(L.x + 4) + '" cy="' + r2(y - 4) + '" r="4"' + F(L.e.color || SERIES[L.i % SERIES.length]) + '/>';
      s += T(L.x + 14, y, L.t1, { sans: 1, size: 11.5, color: 'ink-2' }) + T(L.x + 14 + tw(L.t1, 11.5) * 1.08 + 7, y, L.t2, { size: 11, color: 'ink' });
    });
    return s + '</svg>';
  }

  function Donut(o) {
    o = D(o, { segments: [], size: 104, thickness: 14, legend: true, display: null, sub: null, format: null, label: null });
    var seg = o.segments.filter(function (e) { return e.value > 0; }), tot = sum(seg.map(function (e) { return e.value; })) || 1, f = FMT(o.format);
    var S = o.size, R = S / 2 - 1, r = R - o.thickness, c = S / 2, lw = o.legend ? 150 : 0, W = S + (lw ? 18 + lw : 0), H = Math.max(S, seg.length * 22);
    var cy = H / 2, gapDeg = 2 / ((R + r) / 2) * 180 / Math.PI, a = 0;
    var s = open(W, H, o.label || seg.map(function (e) { return e.label + ' ' + fmt.pct(e.value / tot); }).join(', '));
    seg.forEach(function (e, i) {
      var sw = e.value / tot * 360, cc = e.color || SERIES[i % SERIES.length], t = tip(e.label + ' · ' + f(e.value) + ' (' + fmt.pct(e.value / tot) + ')');
      if (seg.length === 1) s += '<circle cx="' + c + '" cy="' + r2(cy) + '" r="' + r2(R - o.thickness / 2) + '"' + stroke(cc, o.thickness, ';stroke-linecap:butt') + t + '/>';
      else if (sw > gapDeg) s += '<path d="' + sector(c, cy, R, r, a + gapDeg / 2, a + sw - gapDeg / 2) + '"' + F(cc) + t + '/>';
      a += sw;
      if (lw) {
        var ly = cy - (seg.length - 1) * 11 + i * 22 + 4;
        s += rect(S + 18, ly - 8, 8, 8, 2, cc) + T(S + 32, ly, fit(e.label, lw - 50, 12), { sans: 1, size: 12, color: 'ink-2' }) + T(W, ly, fmt.pct(e.value / tot), { size: 11.5, color: 'ink', anchor: 'end' });
      }
    });
    if (o.display) s += T(c, cy + (o.sub ? 2 : 6), o.display, { sans: 1, size: Math.round(r * 0.5), weight: 500, color: 'ink', anchor: 'middle' });
    if (o.sub) s += T(c, cy + 16, o.sub, { size: 9.5, anchor: 'middle' });
    return s + '</svg>';
  }

  function squarify(list, x, y, w, h) {
    var total = sum(list.map(function (d) { return d.value; })) || 1, nodes = list.map(function (d) { return { d: d, a: d.value * w * h / total }; });
    var out = [], box = { x: x, y: y, w: w, h: h }, row = [];
    function worst(rw, len) {
      if (!rw.length) return Infinity; var s = 0, mx = 0, mn = Infinity;
      rw.forEach(function (n) { s += n.a; mx = Math.max(mx, n.a); mn = Math.min(mn, n.a); });
      return Math.max(len * len * mx / (s * s), s * s / (len * len * mn));
    }
    function lay(rw) {
      var s = 0; rw.forEach(function (n) { s += n.a; });
      if (box.w >= box.h) { var cw = s / box.h, yy = box.y; rw.forEach(function (n) { var hh = n.a / cw; out.push({ d: n.d, x: box.x, y: yy, w: cw, h: hh }); yy += hh; }); box.x += cw; box.w -= cw; }
      else { var rh = s / box.w, xx = box.x; rw.forEach(function (n) { var ww = n.a / rh; out.push({ d: n.d, x: xx, y: box.y, w: ww, h: rh }); xx += ww; }); box.y += rh; box.h -= rh; }
    }
    while (nodes.length) {
      var len = Math.min(box.w, box.h), nx = nodes[0];
      if (!row.length || worst(row.concat([nx]), len) <= worst(row, len)) { row.push(nx); nodes.shift(); }
      else { lay(row); row = []; }
    }
    if (row.length) lay(row);
    return out;
  }
  function Treemap(o) {
    o = D(o, { items: [], width: 260, height: 140, color: 'teal', highlight: 0, gap: 2, format: null, label: null });
    var list = o.items.filter(function (d) { return d.value > 0; }).slice().sort(function (a, b) { return b.value - a.value; });
    var W = o.width, H = o.height, f = FMT(o.format), tot = sum(list.map(function (d) { return d.value; })), g = o.gap / 2;
    var hl = typeof o.highlight === 'number' ? (list[o.highlight] || {}).label : o.highlight;
    var s = open(W, H, o.label || list.map(function (d) { return d.label + ' ' + f(d.value); }).join(', '));
    squarify(list, 0, 0, W, H).forEach(function (t) {
      var on = t.d.label === hl, x = t.x + g, y = t.y + g, w = t.w - 2 * g, h = t.h - 2 * g;
      s += rect(x, y, w, h, 4, on ? o.color : soft(o.color), tip(t.d.label + ' · ' + f(t.d.value) + ' (' + fmt.pct(t.d.value / tot) + ')'));
      var tc = on ? 'on-data' : 'ink';
      if (w >= 44 && h >= 24) {
        var lb = fit(t.d.label, w - 14, 11.5);
        if (lb) s += T(x + 7, y + 16, lb, { sans: 1, size: 11.5, weight: 500, color: tc });
        if (h >= 40 && tw(f(t.d.value), 10.5, 1) < w - 12) s += T(x + 7, y + 30, f(t.d.value), { size: 10.5, color: tc });
      }
    });
    return s + '</svg>';
  }

  // =====================================================================
  // COMPARE
  // =====================================================================
  function RankBars(o) {
    o = D(o, { items: [], width: 260, barH: 6, rowH: 32, color: 'teal', max: null, highlight: null, format: null, label: null });
    var d = o.items, W = o.width, f = FMT(o.format), mx = o.max || Math.max.apply(null, d.map(function (e) { return e.value; }).concat([1e-9]));
    var H = d.length * o.rowH - (o.rowH - 18 - o.barH) , s = open(W, H, o.label || d.map(function (e) { return e.label + ' ' + f(e.value); }).join(', '));
    d.forEach(function (e, i) {
      var y0 = i * o.rowH, vt = f(e.value), c = o.highlight == null || o.highlight === i || o.highlight === e.label ? o.color : soft(o.color);
      s += '<g' + tip(e.label + ' · ' + vt) + '>';
      s += T(0, y0 + 11, fit(e.label, W - tw(vt, 11.5, 1) - 12, 12), { sans: 1, size: 12, color: 'ink-2' }) + T(W, y0 + 11, vt, { anchor: 'end', size: 11.5, color: 'ink' });
      s += rect(0, y0 + 18, W, o.barH, o.barH / 2, 'track') + rect(0, y0 + 18, Math.max(o.barH, e.value / mx * W), o.barH, o.barH / 2, c) + '</g>';
    });
    return s + '</svg>';
  }

  function Funnel(o) {
    o = D(o, { stages: [], width: 300, rowH: 30, barH: 18, color: 'teal', labelW: 84, valueW: 84, format: null, label: null });
    var d = o.stages, W = o.width, f = FMT(o.format, function (v) { return fmt.num(v); }), A = W - o.labelW - o.valueW, first = d.length ? d[0].value || 1 : 1;
    var H = d.length * o.rowH - (o.rowH - o.barH), s = open(W, H, o.label || d.map(function (e) { return e.label + ' ' + f(e.value); }).join(', '));
    d.forEach(function (e, i) {
      var w = Math.max(4, e.value / first * A), x = o.labelW + (A - w) / 2, y = i * o.rowH, cy = y + o.barH / 2 + 4;
      var conv = i ? fmt.pct(e.value / (d[i - 1].value || 1)) : '';
      s += '<g' + tip(e.label + ' · ' + f(e.value) + (i ? ' · ' + conv + ' of previous step' : '')) + '>';
      s += T(0, cy, fit(e.label, o.labelW - 8, 12), { sans: 1, size: 12, color: 'ink-2' });
      s += rect(x, y, w, o.barH, 4, o.color);
      s += T(W - 40, cy, f(e.value), { anchor: 'end', size: 11.5, color: 'ink' });
      if (i) s += T(W, cy, conv, { anchor: 'end', size: 10.5 });
      s += '</g>';
    });
    return s + '</svg>';
  }

  function Variance(o) {
    o = D(o, { items: [], width: 300, rowH: 26, barH: 10, labelW: 92, pos: 'rose', neg: 'teal', domain: null, format: 'signed-pct', legend: ['Under budget', 'Over budget'], label: null });
    var d = o.items, W = o.width, f = FMT(o.format), A = W - o.labelW, cx = o.labelW + A / 2, arm = A / 2 - 52;
    var m = o.domain || Math.max.apply(null, d.map(function (e) { return Math.abs(e.value); }).concat([1e-9]));
    var LH = o.legend ? 24 : 0, H = LH + d.length * o.rowH - (o.rowH - 16), s = open(W, H, o.label || d.map(function (e) { return e.label + ' ' + f(e.value); }).join(', '));
    if (o.legend) {
      s += rect(o.labelW, 2, 8, 8, 2, o.neg) + T(o.labelW + 13, 10, o.legend[0], { sans: 1, size: 11, color: 'ink-2' });
      var lx = o.labelW + 13 + tw(o.legend[0], 11) + 16;
      s += rect(lx, 2, 8, 8, 2, o.pos) + T(lx + 13, 10, o.legend[1], { sans: 1, size: 11, color: 'ink-2' });
    }
    s += '<path d="M' + r2(cx) + ',' + (LH - 4) + 'V' + H + '"' + stroke('ink-3', 1, ';stroke-linecap:butt;stroke-opacity:.5') + '/>';
    d.forEach(function (e, i) {
      var y = LH + i * o.rowH, cy = y + 8, len = Math.max(2, Math.abs(e.value) / m * arm), by = cy - o.barH / 2, t = tip(e.label + ' · ' + f(e.value));
      s += T(0, cy + 4, fit(e.label, o.labelW - 8, 12), { sans: 1, size: 12, color: 'ink-2' });
      if (e.value >= 0) s += '<path d="' + rr(cx + 1, by, len, o.barH, 0, 3, 3, 0) + '"' + F(o.pos) + t + '/>' + T(cx + len + 6, cy + 4, f(e.value), { size: 11, color: 'ink' });
      else s += '<path d="' + rr(cx - 1 - len, by, len, o.barH, 3, 0, 0, 3) + '"' + F(o.neg) + t + '/>' + T(cx - len - 6, cy + 4, f(e.value), { size: 11, color: 'ink', anchor: 'end' });
    });
    return s + '</svg>';
  }

  function RangeDots(o) {
    o = D(o, { items: [], domain: null, width: 300, rowH: 26, labelW: 84, color: 'teal', target: null, targetLabel: null, format: null, label: null });
    var d = o.items, W = o.width, f = FMT(o.format), lo, hi;
    if (o.domain) { lo = o.domain[0]; hi = o.domain[1]; } else { lo = Math.min.apply(null, d.map(function (e) { return e.min; })); hi = Math.max.apply(null, d.map(function (e) { return e.max; })); }
    var x0 = o.labelW + 6, x1 = W - 6, sx = function (v) { return x0 + (v - lo) / ((hi - lo) || 1) * (x1 - x0); };
    var H = d.length * o.rowH + 18, s = open(W, H, o.label || d.map(function (e) { return e.label + ' ' + f(e.value) + ' (range ' + f(e.min) + ' to ' + f(e.max) + ')'; }).join(', '));
    if (o.target != null) s += '<path d="M' + r2(sx(o.target)) + ',0V' + (H - 16) + '"' + stroke('ink', 1.5, ';stroke-linecap:butt') + tip(o.targetLabel || 'Target ' + f(o.target)) + '/>';
    d.forEach(function (e, i) {
      var cy = i * o.rowH + o.rowH / 2;
      s += '<g' + tip(e.label + ' · now ' + f(e.value) + ' · range ' + f(e.min) + '–' + f(e.max)) + '>';
      s += T(0, cy + 4, fit(e.label, o.labelW - 6, 12), { sans: 1, size: 12, color: 'ink-2' });
      s += rect(sx(e.min) - 3, cy - 3, sx(e.max) - sx(e.min) + 6, 6, 3, 'track');
      s += '<circle cx="' + r2(sx(e.value)) + '" cy="' + r2(cy) + '" r="5" style="fill:' + col(o.color) + ';stroke:' + col('card') + ';stroke-width:2"/></g>';
    });
    s += T(x0, H - 2, f(lo), { size: 10.5 }) + T(x1, H - 2, f(hi), { size: 10.5, anchor: 'end' });
    if (o.target != null) { var tl = o.targetLabel || f(o.target) + ' target'; s += T(clamp(sx(o.target), x0 + tw(f(lo), 10.5, 1) + tw(tl, 10.5, 1) / 2 + 8, x1 - tw(f(hi), 10.5, 1) - tw(tl, 10.5, 1) / 2 - 8), H - 2, tl, { size: 10.5, anchor: 'middle', color: 'ink-2' }); }
    return s + '</svg>';
  }

  function Waterfall(o) {
    o = D(o, { start: null, steps: [], end: null, width: 300, height: 150, up: 'teal', down: 'rose', total: 'neutral-bar', format: null, label: null });
    var f = FMT(o.format, fmt.inr), fs = function (v) { return (v >= 0 ? '+' : '−') + f(Math.abs(v)); }, W = o.width, H = o.height;
    var bars = [], run = o.start ? o.start.value : 0;
    if (o.start) bars.push({ label: o.start.label, a: 0, b: run, kind: 'total', v: run });
    o.steps.forEach(function (e) { bars.push({ label: e.label, a: run, b: run + e.value, kind: e.value >= 0 ? 'up' : 'down', v: e.value }); run += e.value; });
    // lazarus patch: a closing bar may carry its own figure. The steps arrive rounded to the
    // display scale, so their sum can miss the real closing balance by a rounding step; the bar
    // prints the balance the query returned, not the sum of rounded steps.
    var close = o.end && o.end.value != null ? +o.end.value : run;
    bars.push({ label: (o.end && o.end.label) || 'End', a: 0, b: close, kind: 'total', v: close });
    var lo = Math.min(0, Math.min.apply(null, bars.map(function (b) { return Math.min(b.a, b.b); }))), hi = Math.max.apply(null, bars.map(function (b) { return Math.max(b.a, b.b); }));
    var top = 16, bot = H - 18, sy = function (v) { return top + (1 - (v - lo) / ((hi - lo) || 1)) * (bot - top); };
    var n = bars.length, slot = W / n, bw = Math.min(24, slot * 0.6);
    var s = open(W, H, o.label || bars.map(function (b) { return b.label + ' ' + (b.kind === 'total' ? f(b.v) : fs(b.v)); }).join(', '));
    s += '<path d="M0,' + r2(sy(0) + 0.5) + 'H' + W + '"' + stroke('line', 1, ';stroke-linecap:butt') + '/>';
    bars.forEach(function (b, i) {
      var x = i * slot + (slot - bw) / 2, y1 = sy(Math.max(b.a, b.b)), y2 = sy(Math.min(b.a, b.b)), c = b.kind === 'total' ? o.total : b.kind === 'up' ? o.up : o.down;
      var vt = b.kind === 'total' ? f(b.v) : fs(b.v);
      s += '<path d="' + rr(x, y1, bw, Math.max(1.5, y2 - y1), 3, 3, b.kind === 'total' ? 0 : 3, b.kind === 'total' ? 0 : 3) + '"' + F(c) + tip(b.label + ' · ' + vt) + '/>';
      if (i < n - 1) s += '<path d="M' + r2(x + bw) + ',' + r2(sy(b.b)) + 'H' + r2((i + 1) * slot + (slot - bw) / 2) + '"' + stroke('ink-3', 1, ';stroke-linecap:butt;stroke-opacity:.5') + '/>';
      s += T(x + bw / 2, y1 - 5, vt, { anchor: 'middle', size: 9.5, color: b.kind === 'total' ? 'ink' : 'ink-2' });
      s += T(x + bw / 2, H - 3, fit(b.label, slot - 2, 9.5, 1), { anchor: 'middle', size: 9.5 });
    });
    return s + '</svg>';
  }

  function DotHistogram(o) {
    o = D(o, { values: [], domain: null, width: 260, dot: 7, gap: 1.5, color: 'teal', over: 'rose', threshold: null, thresholdLabel: null, median: true, format: null, label: null });
    var v = o.values.slice().sort(function (a, b) { return a - b; }), W = o.width, f = FMT(o.format, fmt.days), p = o.dot + o.gap;
    var lo = o.domain ? o.domain[0] : v[0], hi = o.domain ? o.domain[1] : v[v.length - 1], bins = Math.max(1, Math.floor(W / p)), bs = ((hi - lo) || 1) / bins, counts = [];
    for (var b = 0; b < bins; b++) counts.push(0);
    var placed = v.map(function (x) { var k = clamp(Math.floor((x - lo) / bs), 0, bins - 1); counts[k]++; return { x: x, k: k, j: counts[k] - 1 }; });
    var mc = Math.max.apply(null, counts.concat([1])), top = 16, plotH = mc * p, base = top + plotH, H = base + 18;
    var sx = function (x) { return (x - lo) / ((hi - lo) || 1) * (bins * p); };
    var med = v.length ? (v.length % 2 ? v[(v.length - 1) / 2] : (v[v.length / 2 - 1] + v[v.length / 2]) / 2) : 0;
    var late = o.threshold != null ? v.filter(function (x) { return x > o.threshold; }).length : 0;
    var s = open(W, H, o.label || (v.length + ' values, median ' + f(med) + (o.threshold != null ? ', ' + late + ' above ' + f(o.threshold) : '')));
    placed.forEach(function (d) {
      var c = o.threshold != null && d.x > o.threshold ? o.over : o.color;
      s += '<circle cx="' + r2(d.k * p + o.dot / 2) + '" cy="' + r2(base - d.j * p - o.dot / 2 - 1) + '" r="' + r2(o.dot / 2) + '"' + F(c) + tip(f(d.x)) + '/>';
    });
    s += '<path d="M0,' + r2(base + 0.5) + 'H' + W + '"' + stroke('line', 1, ';stroke-linecap:butt') + '/>';
    if (o.threshold != null) {
      var xt = sx(o.threshold) + o.gap / 2 - 0.75, tl = o.thresholdLabel || f(o.threshold);
      s += '<path d="M' + r2(xt) + ',' + (top - 4) + 'V' + r2(base + 4) + '"' + stroke('ink', 1.5, ';stroke-linecap:butt') + '/>';
      s += T(clamp(xt, tw(tl, 10.5, 1) / 2, W - tw(tl, 10.5, 1) / 2), 10, tl, { anchor: 'middle', size: 10.5, color: 'ink-2' });
    }
    s += T(0, H - 2, f(lo), { size: 10.5 }) + T(W, H - 2, f(hi), { size: 10.5, anchor: 'end' });
    if (o.median) { var mt = 'median ' + f(med), mx = clamp(sx(med), tw(mt, 10.5, 1) / 2 + tw(f(lo), 10.5, 1) + 6, W - tw(mt, 10.5, 1) / 2 - tw(f(hi), 10.5, 1) - 6); s += '<path d="M' + r2(sx(med)) + ',' + r2(base + 1) + 'v4"' + stroke('ink-3', 1.5) + '/>' + T(mx, H - 2, mt, { size: 10.5, anchor: 'middle', color: 'ink-2' }); }
    return s + '</svg>';
  }

  // =====================================================================
  // TIME
  // =====================================================================
  function DayTimeline(o) {
    o = D(o, { start: 8, end: 18, now: null, events: [], width: 260, tickEvery: 2, block: 16, color: 'rose', label: null });
    var W = o.width, pad = 6, y = 12, sx = function (t) { return pad + (t - o.start) / (o.end - o.start) * (W - 2 * pad); }, H = 42;
    var hh = function (t) { var h = Math.floor(t), m = Math.round((t - h) * 60); return ((h % 12) || 12) + ':' + (m < 10 ? '0' : '') + m + (h < 12 ? ' AM' : ' PM'); };
    var nx = o.now != null ? sx(clamp(o.now, o.start, o.end)) : pad;
    var s = open(W, H, o.label || (o.events.length + ' events' + (o.now != null ? ', now ' + hh(o.now) : '')));
    s += '<path d="M' + r2(nx) + ',' + y + 'H' + (W - pad) + '"' + stroke('line', 1.5) + '/>';
    if (o.now != null) s += '<path d="M' + pad + ',' + y + 'H' + r2(nx) + '"' + stroke('ink-3', 1.5) + '/>';
    o.events.forEach(function (e) {
      var x = sx(e.start), w = Math.max(o.block, sx(e.end != null ? e.end : e.start + 0.5) - x);
      s += rect(x, y - o.block / 2, w, o.block, 5, e.strong ? o.color : soft(o.color), tip(hh(e.start) + ' · ' + (e.label || 'Event')));
    });
    if (o.now != null) s += rect(nx - 1.5, y - 10, 3, 20, 1.5, 'now', tip('Now · ' + hh(o.now)));
    for (var t = o.start; t <= o.end + 1e-9; t += o.tickEvery) {
      var anc = t === o.start ? 'start' : t >= o.end - 1e-9 ? 'end' : 'middle';
      s += T(anc === 'start' ? sx(t) - pad : anc === 'end' ? sx(t) + pad : sx(t), H - 2, String((Math.floor(t) % 12) || 12), { anchor: anc, size: 11 });
    }
    return s + '</svg>';
  }

  function DueDates(o) {
    o = D(o, { days: 30, today: 1, items: [], width: 300, colors: null, label: null });
    var C = o.colors || { done: 'teal', due: 'ink-2', late: 'rose' }, NAME = { done: 'done', due: 'upcoming', late: 'overdue' };
    var W = o.width, pad = 8, sx = function (d) { return pad + (d - 1) / ((o.days - 1) || 1) * (W - 2 * pad); }, y = 38, H = 58;
    var s = open(W, H, o.label || o.items.map(function (e) { return e.label + ' day ' + e.day + ' ' + (NAME[e.state] || e.state); }).join(', '));
    s += '<path d="M' + pad + ',' + y + 'H' + (W - pad) + '"' + stroke('line', 1.5) + '/>';
    s += '<path d="M' + pad + ',' + y + 'H' + r2(sx(o.today)) + '"' + stroke('ink-3', 1.5) + '/>';
    var rows = [-1e9, -1e9];
    o.items.slice().sort(function (a, b) { return a.day - b.day; }).forEach(function (e) {
      var x = sx(e.day), lw = tw(e.label, 10, 1), row = x - lw / 2 > rows[0] + 6 ? 0 : 1; rows[row] = x + lw / 2;
      var ly = row ? 9 : 22, t = tip(e.label + ' · day ' + e.day + ' · ' + (NAME[e.state] || e.state));
      s += '<g' + t + '>';
      s += '<path d="M' + r2(x) + ',' + (ly + 3) + 'V' + (y - 7) + '"' + stroke('grid', 1, ';stroke-linecap:butt') + '/>';
      if (e.state === 'done') s += '<circle cx="' + r2(x) + '" cy="' + y + '" r="6"' + F(C.done) + '/><path d="M' + r2(x - 2.8) + ',' + y + 'l1.9,1.9l3.6,-3.8"' + stroke('card', 1.6) + '/>';
      else if (e.state === 'late') s += '<circle cx="' + r2(x) + '" cy="' + y + '" r="6"' + F(C.late) + '/><path d="M' + r2(x) + ',' + (y - 3) + 'v3.2M' + r2(x) + ',' + (y + 2.6) + 'v0.2"' + stroke('card', 1.8) + '/>';
      else s += '<circle cx="' + r2(x) + '" cy="' + y + '" r="5" style="fill:' + col('card') + ';stroke:' + col(C.due) + ';stroke-width:1.8"/>';
      s += T(clamp(x, lw / 2, W - lw / 2), ly, e.label, { anchor: 'middle', size: 10, color: e.state === 'late' ? 'ink' : 'ink-2' }) + '</g>';
    });
    s += rect(sx(o.today) - 1.5, y - 8, 3, 16, 1.5, 'now', tip('Today · day ' + o.today));
    s += T(pad - 2, H - 1, '1', { size: 10 }) + T(W - pad + 2, H - 1, String(o.days), { size: 10, anchor: 'end' });
    var tt = 'today', tx = clamp(sx(o.today), tw(tt, 10, 1) / 2 + 16, W - tw(tt, 10, 1) / 2 - 20);
    s += T(tx, H - 1, tt, { size: 10, anchor: 'middle', color: 'ink-2' });
    return s + '</svg>';
  }

  // =====================================================================
  // runtime: JSON specs, mounting, hover tooltips
  // =====================================================================
  var api = {
    Card: Card, SegmentGauge: SegmentGauge, Ring: Ring, ArcGauge: ArcGauge, TickMeter: TickMeter, BulletBar: BulletBar, Steps: Steps,
    Waffle: Waffle, Rings: Rings, TickRing: TickRing, Sparkline: Sparkline, MiniBars: MiniBars, PosNegBars: PosNegBars,
    CalendarHeat: CalendarHeat, UptimeStrip: UptimeStrip, Slope: Slope, SegmentBar: SegmentBar, Donut: Donut, Treemap: Treemap,
    RankBars: RankBars, Funnel: Funnel, Variance: Variance, RangeDots: RangeDots, Waterfall: Waterfall, DotHistogram: DotHistogram,
    DayTimeline: DayTimeline, DueDates: DueDates
  };
  // chart({type:'BulletBar', ...options}) -> SVG string. Lets a server or an LLM emit plain JSON.
  function chart(spec) {
    if (!spec || !api[spec.type]) return '<svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="unknown chart"></svg>';
    var o = {}; for (var k in spec) if (k !== 'type') o[k] = spec[k];
    return api[spec.type](o);
  }
  var tipEl = null;
  function hover(root) {
    root = root || document.body;
    if (!root || root.__glHover || typeof document === 'undefined') return; root.__glHover = true;
    // lazarus patch: Turbo swaps <body> on every visit, detaching the old tip, so re-create it when gone.
    if (!tipEl || !tipEl.isConnected) { tipEl = document.createElement('div'); tipEl.className = 'gl-tip'; tipEl.setAttribute('role', 'tooltip'); document.body.appendChild(tipEl); }
    function hide() { tipEl.style.opacity = '0'; }
    root.addEventListener('pointermove', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-tip]') : null;
      if (!t || !root.contains(t)) return hide();
      tipEl.textContent = t.getAttribute('data-tip'); tipEl.style.opacity = '1';
      var w = tipEl.offsetWidth, h = tipEl.offsetHeight, vw = document.documentElement.clientWidth;
      tipEl.style.left = clamp(e.clientX - w / 2, 4, vw - w - 4) + 'px';
      tipEl.style.top = (e.clientY - h - 12 < 4 ? e.clientY + 16 : e.clientY - h - 12) + 'px';
    });
    root.addEventListener('pointerleave', hide);
  }
  // render(el, 'BulletBar', opts) — draws at the element's width and redraws on resize
  function render(el, type, opts) {
    if (!el || !api[type]) return;
    opts = opts || {};
    function draw() { var w = Math.floor(el.clientWidth), o = {}; for (var k in opts) o[k] = opts[k]; if (w && opts.width == null) o.width = w; el.innerHTML = api[type](o); }
    draw();
    if (typeof ResizeObserver !== 'undefined' && !el.__glRO) {
      var last = el.clientWidth;
      el.__glRO = new ResizeObserver(function () { if (Math.abs(el.clientWidth - last) > 1) { last = el.clientWidth; draw(); } });
      el.__glRO.observe(el);
    }
    hover(el);
  }
  // hydrate(root) — renders every [data-gl] placeholder that Card({chart:{type,...}}) left behind
  function hydrate(root) {
    root = root || document;
    var list = root.querySelectorAll('[data-gl]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i], spec; try { spec = JSON.parse(el.getAttribute('data-gl')); } catch (e) { continue; }
      el.removeAttribute('data-gl');
      var o = {}; for (var k in spec) if (k !== 'type') o[k] = spec[k];
      render(el, spec.type, o);
    }
    hover(root.body || root);
  }

  // lazarus patch: plot.js draws with the same helpers, so its charts match these ones.
  api.kit = { col: col, soft: soft, esc: esc, r2: r2, clamp: clamp, D: D, tw: tw, fit: fit, tip: tip, T: T, open: open, rr: rr, rect: rect, stroke: stroke, FMT: FMT, SERIES: SERIES };
  api.chart = chart; api.render = render; api.hydrate = hydrate; api.hover = hover; api.fmt = fmt; api.color = col; api.series = SERIES.slice();
  var G = typeof window !== 'undefined' ? window : this;
  G.Glance = G.Glance || {};
  for (var name in api) G.Glance[name] = api[name];
})();
